import { Component, EventEmitter, OnInit, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { ToastService } from 'angular-toastify';
import { ApiAuthService } from '../../../../../core/services/api/auth/api-auth.service';
import { MapperMyProfileService } from '../../../../../core/mappers/auth/mapper-my-profile.service';
import { ModalChangeMyPasswordComponent } from '../modal-change-my-password/modal-change-my-password.component';

@Component({
  selector: 'app-modal-my-profile',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalChangeMyPasswordComponent],
  templateUrl: './modal-my-profile.component.html',
  styleUrl: './modal-my-profile.component.css',
})
export class ModalMyProfileComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  @Output() saved = new EventEmitter<string>();

  login = '';
  displayName = '';
  email = '';
  phone = '';
  roleName = '';
  hasCityPassword = false;
  isPasswordModalOpen = false;

  isLoading = signal(false);
  isSaving = signal(false);

  private api = inject(ApiAuthService);
  private mapper = inject(MapperMyProfileService);
  private toast = inject(ToastService);
  private cookieService = inject(CookieService);

  ngOnInit(): void {
    this.loadProfile();
  }

  onClose(): void {
    this.close.emit();
  }

  openPasswordModal(): void {
    if (!this.hasCityPassword) return;
    this.isPasswordModalOpen = true;
  }

  closePasswordModal(): void {
    this.isPasswordModalOpen = false;
  }

  onSave(): void {
    if (this.isSaving()) return;

    if (!this.displayName.trim()) {
      this.toast.error('กรุณาระบุชื่อที่แสดง');
      return;
    }

    this.isSaving.set(true);
    const profilePayload = this.mapper.mapUpdatePayload({
      displayName: this.displayName,
      email: this.email,
      phone: this.phone,
    });

    this.api.updateMyProfile(profilePayload).subscribe({
      next: (res) => {
        this.isSaving.set(false);
        if (!res?.isSuccess) {
          this.toast.error(res?.message || 'บันทึกข้อมูลส่วนตัวไม่สำเร็จ');
          return;
        }
        this.cookieService.set('name', this.displayName.trim(), undefined, '/');
        this.toast.success('บันทึกข้อมูลส่วนตัวเรียบร้อย');
        this.saved.emit(this.displayName.trim());
        this.close.emit();
      },
      error: () => {
        this.isSaving.set(false);
        this.toast.error('เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์');
      },
    });
  }

  private loadProfile(): void {
    this.isLoading.set(true);
    this.api.getMyProfile().subscribe({
      next: (dto) => {
        const profile = this.mapper.mapFromDto(dto);
        this.login = profile.login;
        this.displayName = profile.displayName;
        this.email = profile.email;
        this.phone = profile.phone;
        this.roleName = profile.roleName;
        this.hasCityPassword = profile.hasCityPassword;
        this.isLoading.set(false);
      },
      error: () => {
        this.isLoading.set(false);
        this.toast.error('ไม่สามารถโหลดข้อมูลส่วนตัวได้');
      },
    });
  }
}
